import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { FinanceAccessRulesKeyEnum } from './finance-access-rules-key.enum';
import { FinanceAccessRulesConst } from './finance-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class FinanceAccessService extends BaseAccessService<FinanceAccessRulesKeyEnum> {
  public constructor() {
    super(FinanceAccessRulesConst);
  }

  // --- Бюджетирование ---
  public get planFactRights() {
    return {
      canReadBalanceReport: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_REPORT_READ]
      ),
      canWriteBalanceReport: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_REPORT_WRITE]
      ),
      canReadSettings: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_SETTINGS_READ]
      ),
      canWriteSettings: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_SETTINGS_WRITE]
      ),
      canReadPaymentOutgoing: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PAYMENT_OUTGOING_READ]
      ),
      canReadBudgetRequest: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BUDGET_REQUEST_READ]
      ),
      canWriteBudgetRequest: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BUDGET_REQUEST_WRITE]
      ),
      canReadBalanceSheet: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_SHEET_READ]
      ),
      canReadPlanningScenario: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PLANNING_SCENARIO_READ]
      ),
      canWritePlanningScenario: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PLANNING_SCENARIO_WRITE]
      )
    };
  }

  public get planFactPermissions() {
    return {
      canAccessToAllBudgetRequests: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_ACCESS_TO_ALL_BUDGET_REQUESTS]
      ),
      canEditAllBudgetRequests: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_ALL_BUDGET_REQUESTS]
      ),
      canDeleteAllBudgetRequestsComments: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_DELETE_ALL_BUDGET_REQUESTS_COMMENTS]
      ),
      canApproveBudgetRequestInsteadOfAnother: this.globalService.isAccessRule(
        FinanceAccessRulesConst[
          FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_CAN_APPROVE_BUDGET_REQUEST_INSTEAD_OF_ANOTHER
        ]
      ),
      canEditPreviousPlan: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_PREVIOUS_PLAN]
      ),
      canEditDocumentRestrictDate: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_DOCUMENT_RESTRICT_DATE]
      )
    };
  }

  // --- Документы ---
  public get documentRights() {
    return {
      canReadDocument: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_REGISTRY_READ]
      ),
      canWriteDocument: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_REGISTRY_WRITE]
      ),
      canReadTemplate: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_TEMPLATE_READ]
      ),
      canWriteTemplate: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_TEMPLATE_WRITE]
      ),
      canReadVerify: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_VERIFY_READ]
      ),
      canWriteVerify: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_VERIFY_WRITE]
      ),
      canReadBankStatementRule: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_BANK_STATEMENT_RULE_READ]
      ),
      canWriteBankStatementRule: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_BANK_STATEMENT_RULE_WRITE]
      ),
      canReadABCAnalysis: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_ABC_ANALYSIS_READ]
      ),
      canReadSalaryAccrual: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_ACCRUAL_READ]
      ),
      canWriteSalaryAccrual: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_ACCRUAL_WRITE]
      ),
      canReadSalaryDistribution: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_DISTRIBUTION_READ]
      ),
      canWriteSalaryDistribution: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_DISTRIBUTION_WRITE]
      ),
      canReadAnalyticsReset: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_ANALYTICS_RESET_READ]
      )
    };
  }

  public get documentPermissions() {
    return {
      canEditOtherUserDocuments: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_EDIT_OTHER_USER_DOCUMENTS]
      ),
      canLockDocuments: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_CAN_LOCK_DOCUMENTS]
      ),
      canReadOtherUserBills: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_READ_OTHER_USER_BILLS]
      ),
      canEditOtherUserBills: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_EDIT_OTHER_USER_BILLS]
      )
    };
  }

  // --- Сделки ---
  public get dealRights() {
    return {
      canReadDeal: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_READ]
      ),
      canWriteDeal: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_WRITE]
      ),

      canReadDealsGroup: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEALS_GROUP_READ]
      ),
      canWriteDealsGroup: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEALS_GROUP_WRITE]
      ),

      canReadIntegrationMegaplan: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_READ]
      ),
      canWriteIntegrationMegaplan: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_WRITE]
      ),

      canReadIntegrationAmo: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_AMO_READ]
      ),
      canWriteIntegrationAmo: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_AMO_WRITE]
      ),

      canReadDealType: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_TYPE_READ]
      ),
      canWriteDealType: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_TYPE_WRITE]
      ),

      canReadDealStatus: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_STATUS_READ]
      ),
      canWriteDealStatus: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_STATUS_WRITE]
      ),

      canReadRentalRate: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_RENTAL_RATES_READ]
      ),
      canWriteRentalRate: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_RENTAL_RATES_WRITE]
      ),
      isRentalRatesTabEnabled: this.globalService.isAccessRule({
        'BUSINESS.enabled': true,
        'BUSINESS.sections.BUSINESS.tabs.RENTAL_RATES.enabled': true
      })
    };
  }

  public get dealPermissions() {
    return {
      canReadAllDeals: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_READ_ALL_DEALS]
      ),
      canDeleteOtherUserDealComments: this.globalService.isAccessRule(
        FinanceAccessRulesConst[FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DELETE_OTHER_USER_DEAL_COMMENTS]
      )
    };
  }
}
